export const GET_WHITE_LISTED_DEVICES = "GET_WHITE_LISTED_DEVICES";

export const CREATE_WHITE_LISTED_DEVICE = "CREATE_WHITE_LISTED_DEVICE";
export const EDIT_WHITE_LISTED_DEVICE = "EDIT_WHITE_LISTED_DEVICE";
export const DELETE_WHITE_LISTED_DEVICE = "DELETE_WHITE_LISTED_DEVICE";

export const OPEN_WHITE_LISTED_DEVICE_DIALOG = "OPEN_WHITE_LISTED_DEVICE_DIALOG";
export const CLOSE_WHITE_LISTED_DEVICE_DIALOG = "CLOSE_WHITE_LISTED_DEVICE_DIALOG";

